function onAvailable(n,i,o){if(void 0!==n&&void 0!==i){n.constructor!==Array&&(n=[n]),void 0===o&&(o=100);var w=function(n){n=n.split(".");for(var i=window[n.shift()];i&&n.length;)i=i[n.shift()];return void 0!==i},r="$_onAvailableIntervals",t="$_onAvailableCallbacks";window[r]=window[r]||[],window[t]=window[t]||[],window[t].push(i);var a=window[t].length-1;window[r].push(setInterval(function(n,i){return function(){for(var o=!0,a=0;a<i.length;a++)o=o&&w(i[a]);o&&(clearInterval(window[r][n]),void 0!==window[t][n]&&window[t][n]())}}(a,n),o))}};
onAvailable(['jQuery', 'Mustache'],  function() {
    (function($){
        // START WEB SDK CODE
        $('[data-websdk]').each(function () {

            // vars
            var container = $(this);
            var model_name = container.data('websdk');
            var id = container.attr('id');
            var custom_template = container.data('template');
            var template_id;
            var config;
            var model;
            var template;
            var html;
            console.log(custom_template);

            // setting vars
            template_id = custom_template ? custom_template : '#' + id + '_template';
            template = $(template_id).text();

            if (typeof websdk_config !== 'undefined'
                && typeof websdk_config[id] !== 'undefined'
                && typeof $fbsdk !== 'undefined' ) {
                config = websdk_config[id];
                $fbsdk.Config.baseHost = config.baseHost;


                if (model_name === 'Offers') {

                    model = new $fbsdk[model_name](config.params);
                    model.setAuthToken(config._authCode);
                    model.load(function (error) {
                        var data, i;
                        if (!error) {
                            data = this.getRawData();
                            if(!isEmpty(data.rates)) {
                                // exclude option

                                if (typeof config.excludedOffers !== 'undefined' && config.excludedOffers !== '') {

                                    data.rates = data.rates.filter(function(el) {
                                        return (config.excludedOffers.indexOf(el.rate.name) == -1);
                                    });

                                }

                                // limit numbers
                                if (typeof config.offersNumber !== 'undefined' && config.offersNumber !== '') {
                                    if(data.rates.length > parseInt(config.offersNumber, 10)) {
                                        data.rates.length = parseInt(config.offersNumber, 10);
                                    }
                                }


                                html = Mustache.render(template, data);
                                container.html(html);

                                var offersCtaArray = $('.card-header__cta');
                                if (offersCtaArray.length) {
                                    offersCtaArray.each(function (index) {
                                        $(this).on('click', function () {
                                            $(this).closest('.offers-card').toggleClass('offers-card--onfocus');
                                        });
                                    });
                                }

                                var offersCarousel = document.querySelector('.offers-carousel');
                                if ( offersCarousel ) {
                                    var offersCarousel = new Flickity(offersCarousel, {
                                        cellAlign: 'center',
                                        contain: true,
                                        prevNextButtons: false,
                                        pageDots: true,
                                        imagesLoaded: true,
                                        resize: true,
                                        watchCSS: true
                                    });
                                }

                                if( typeof objectFitImages === 'function' ){
                                    objectFitImages();
                                }
                                if( typeof window.myLazyLoad !== 'undefined' ){
                                    window.myLazyLoad.update();
                                }

                            } else {
                                // NO OFFERS
                                // CALLBACKS
                                // var container = $('.offers-container');
                                container.remove();
                            }
                        }
                    });
                }

                if (model_name === 'StartingFrom') {

                    // Override  getOptionalParams for StartingFrom

                    var optionalParams = $fbsdk.StartingFrom.prototype.getOptionalParams();
                    optionalParams.push('output');
                    optionalParams.push('roomRestriction');
                    $fbsdk.StartingFrom.prototype.getOptionalParams = function() {return optionalParams;}

                    model = new $fbsdk[model_name](config.params);
                    model.setAuthToken(config._authCode);


                    model.load(function (error) {
                        var data, i;
                        if (!error) {
                            data = this.getRawData();
                            if(!isEmpty(data.quotation)) {
                                html = Mustache.render(template, data);
                                container.html(html);
                            }
                        }
                    });
                }

            }
        });
        // END WEB SDK CODE

    })(jQuery);

    // var offersCtaArray = document.querySelectorAll('.card-header__cta');
    // if (offersCtaArray.length) {
    //     offersCtaArray.forEach(function (index) {
    //         index.addEventListener('click', function () {
    //             index.parentElement.parentElement.classList.toggle('offers-card--onfocus');
    //         });
    //     });
    // }
});